import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {environment as env} from '../../../../environments/environment';

@Component({
    selector: 'sd-verify-phone',
    templateUrl: './verify-phone.component.html'
})
export class VerifyPhoneComponent implements OnInit {
    message;
    code;
    phone;
    requestPhone = false;
    error;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public httpClient: HttpClient
    ) {
    }

    ngOnInit() {
        let user = JSON.parse(localStorage.getItem('User'));

        if (user.phone && user.phone_verified == false) {
            this.phone = user.phone;
            // this.request();
        }
    }

    

    headers() {
        return new HttpHeaders().set('Access-Token', this.getToken());
    }

    getToken() {
        return localStorage.getItem('Access-Token-Icheck');
    }
}


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/auth/verify-phone.component.ts